import serviceAccounts from '@/apis/coreIAM/serviceAccounts'
import { serviceAccountsTypes } from '@/store/mutationTypes'

export default {
    state: {
        retrieveCredentials: {
            pending: false,
            error: null,
        },
    },
    mutations: {
        [serviceAccountsTypes.RETRIEVE_CREDENTIALS_REQUEST]: function (state) {
            state.retrieveCredentials.pending = true;
        },
        [serviceAccountsTypes.RETRIEVE_CREDENTIALS_SUCCESS]: function (state) {
            state.retrieveCredentials.error = null;
            state.retrieveCredentials.pending = false;
        },
        [serviceAccountsTypes.RETRIEVE_CREDENTIALS_FAILURE]: function (state, error) {
            state.retrieveCredentials.error = error;
            state.retrieveCredentials.pending = false;
        },
    },
    actions: {
        async retrieveCredentials({ commit }, payload) {
            commit(serviceAccountsTypes.RETRIEVE_CREDENTIALS_REQUEST)
            return new Promise((resolve, reject) => {
                serviceAccounts
                    .getServiceAccountSecret(payload.uuid)
                    .then((secret) => {
                        commit(serviceAccountsTypes.RETRIEVE_CREDENTIALS_SUCCESS)
                        resolve(secret.data)
                    })
                    .catch((error) => {
                        commit(serviceAccountsTypes.RETRIEVE_CREDENTIALS_FAILURE, error)
                        reject(error)
                    })
            })
        },
    }
}